import { Button, Col, Row } from 'react-bootstrap';
import { AlertTriangle } from 'react-feather';
import styles from '../activate-account/activate-account.module.scss';

export function InvalidVerificationLink() {
  return (
    <>
      <Row>
        <Col>
          <p className={'header'}>We can't verify your email</p>
          <p className={'subtext'}>
            This verification link is invalid or has expired.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <div
            className={styles['error-panel']}
            role={'alert'}
            data-testid={'invalid-verification-link'}
          >
            <div className={styles['error-icon']} aria-hidden={'true'}>
              <AlertTriangle size={16} strokeWidth={2} />
            </div>
            <div className={styles['error-text']}>
              Please sign up again to receive a new verification email.
            </div>
          </div>
        </Col>
      </Row>
      <Row className={'form-button-row'}>
        <Col>
          <Button
            href={'/register?registration=ix-one'}
            color="primary"
            style={{ width: '100%' }}
          >
            Back to sign up
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default InvalidVerificationLink;
